import React, { Component } from 'react'
import { Redirect, withRouter, Link } from 'react-router-dom'
import axios from 'axios'
import { errorNotification, loginUrl, successNotification } from '../config'
import WithUser from 'hocs/WithUser'
import PropTypes from 'prop-types'
import { Input } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

class LoginForm extends Component {
  state = {
    email: '',
    password: '',
    otp: '',
    phoneNumber: '',
    otpSent: false,
    isSubmitting: false,
    redirectToReferrer: false,
    errorMessage: {},
    showModal: false
  }

  handleInputUpdate = (stateName, event) => {
    this.setState({ [stateName]: event.target.value })
  }

  handleSubmit = event => {
    event.preventDefault()
    this.setState({ isSubmitting: true })
    let data = this.state
    axios
      .post(loginUrl, data)
      .then(res => {
        let userData = res.data
        if (userData.user.isStaff && userData.user.isActive) {
          this.props.setUser({
            ...userData,
            user: { ...userData.user, id: userData.user.pk }
          })
          this.setState({ redirectToReferrer: true })
          successNotification('Login successful')
        } else {
          errorNotification('Access restricted.')
          this.setState({ isSubmitting: false })
        }
      })
      .catch(error => {
        if (error.response && error.response.status < 500) {
          this.setState({ errorMessage: error.response.data })
        } else {
          this.setState({
            errorMessage: {
              nonFieldErrors: ['Oops! Something happened. Please try again.']
            }
          })
        }

        this.setState({ isSubmitting: false })
      })
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } }
    const redirectPath = from.pathname
    const { redirectToReferrer } = this.state

    if (redirectToReferrer === true) {
      return <Redirect to={redirectPath} />
    }

    return (
      <React.Fragment>
        <form className="mt-2rem" onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="col-md-12 mb-1rem">
              <label htmlFor="phoneNumber" style={{ fontWeight: '700' }}>
                Phone Number
              </label>
              <Input
                className=""
                placeholder="0245880899"
                onChange={this.handleInputUpdate.bind(this, 'phoneNumber')}
                autoFocus="autofocus"
                autoComplete="phoneNumber"
                required
              />
              {this.state.errorMessage.phoneNumber
                ? this.state.errorMessage.phoneNumber.map((err, i) => (
                    <p key={i} style={{ color: 'red', marginTop: '1em' }}>
                      {err}
                    </p>
                  ))
                : null}
            </div>
            <div className="col-md-12 mt-2rem">
              <label htmlFor="password" style={{ fontWeight: '700' }}>
                Password
              </label>
              <Input.Password
                className=""
                placeholder="Enter password"
                type="password"
                onChange={this.handleInputUpdate.bind(this, 'password')}
                autoComplete="current-password"
                required
              />
              {this.state.errorMessage.password
                ? this.state.errorMessage.password.map((err, i) => (
                    <p key={i} style={{ color: 'red', marginTop: '1em' }}>
                      {err}
                    </p>
                  ))
                : null}
              <div
                style={{
                  color: 'rgb(0 66 65 / 69%)',
                  fontSize: '1.3rem',
                  marginTop: '0.5rem'
                }}
              >
                Can't remember your password?{' '}
                <Link to="/auth/password-reset">
                  <span className="navbar__link--active">Reset it Now</span>
                </Link>
              </div>
            </div>
          </div>
          <div>
            {this.state.errorMessage.nonFieldErrors
              ? this.state.errorMessage.nonFieldErrors.map((err, i) => (
                  <p key={i} style={{ color: 'red', marginTop: '1em' }}>
                    {err}
                  </p>
                ))
              : null}
          </div>

          <div className="form__submit mt-3rem">
            <button
              className="btn btn--custom-one btn--width-lng mt-2rem mb-1rem"
              type="submit"
            >
              {this.state.isSubmitting ? <LoadingOutlined /> : 'Login'}
            </button>
          </div>
        </form>
      </React.Fragment>
    )
  }
}

LoginForm.propTypes = {
  setUser: PropTypes.func,
  location: PropTypes.shape({
    state: PropTypes.object
  })
}

export default withRouter(WithUser(LoginForm))
